import { showLogConsole } from "@/commons/utils"

export function usePdfDownload() {
  const baixarArquivo = (url, token) => {
    fetch(url, {
      headers: { Authorization: 'Bearer ' + token }
    })
      .then((r) => r.blob())
      .then((blob) => {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'arquivo.pdf'
        link.click()
        URL.revokeObjectURL(link.href)
      })
      .catch((err) => {
        showLogConsole('Erro ao baixar o arquivo:', err)
      })
  }

  return { baixarArquivo }
}
